import Blockly from "blockly/core";
import en from "blockly/msg/en";

Blockly.setLocale(en);
